export default __webpack_public_path__ + "static/media/FSKoopman-Italic.49277fb4.woff";